<template>
  <div class="call-container">
    <div class="bk">
      <div>联系我们</div>
    </div>
    <!-- <div
      class="change"
      :class="currentIndex == index ? 'current' : ''"
      :key="item.id"
      v-for="(item, index) in list"
    ></div> -->

    <ul class="scrollContainer">
      <li
        class="item"
        :class="currentIndex == index ? 'active' : ''"
        v-for="(item, index) in list"
        :key="item.id"
        @click="change(index)"
      >
        <!-- <i></i> -->
        <p class="header-title">{{ item.title }}</p>
      </li>
    </ul>
    <div class="information">
      <div class="all">
        <!--  -->
        <div class="title">{{ list[this.index].title2 }}</div>
        <p>{{ list[this.index].address }}</p>
        <p>{{ list[this.index].phone1 }}</p>
        <p>{{ list[this.index].phonenew }}</p>
        <p>{{ list[this.index].website }}</p>
        <p>{{ list[this.index].eMaill }}</p>
        <!-- <div class="name">{{ list[this.index].title }}</div> -->
        <!-- <p>地址:深圳市盐田区沙头角深盐路保发大厦5楼整</p>
        <p>总机: 0755-83932176</p>
        <p>市场中心直线 (网约车产品) : 0755-83934003</p>
        <p>市场二中心直线（车联网、两客一危）：0755-83932665</p>
        <p>传真：0755-83932552</p>
        <p>全国服务热线：4001 837544</p>
        <p>公司网站：www.szce.com</p>
        <p>E-mail: changen@szce.com</p> -->
      </div>
    </div>
    <div class="bom">
      <span>
        版权所有©深圳昌恩智能股份有限公司　
        <a style="color: #fff" target="_blank" href="http://beian.miit.gov.cn"
          >粤ICP备17113788号</a
        ></span
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'call',
  data () {
    return {
      currentIndex: 0,
      index: 0,
      list: [
        {
          id: 1, //用来代表每一个对象
          title: '深圳总部', //标题
          title2: '深圳昌恩智能股份有限公司',
          address: '地址：深圳市盐田区深盐路南保发大厦5楼',
          phone1: '总机：0755-83932176',
          phonenew: '智慧交通事业部：13691705316',
          website: '公司网站：www.szce.com',
          eMaill: 'E-mail:  changen@szce.com'
        },
        {
          id: 2, //用来代表每一个对象
          title: '深圳市昌恩碳中科技有限公司', //标题
          title2: '深圳市昌恩碳中科技有限公司',
          address:
            '地址：深圳市福田区沙头街道天安社区泰然四路25号天安创新科技广场一期B座1310B.C',
          phone1: '电话：0755-83932176'
        },
        {
          id: 3, //用来代表每一个对象
          title: '智慧交通服务中心', //标题
          title2: '智慧交通服务中心',
          address: '地址：深圳市盐田区深盐路保发大厦1楼',
          phone1: '电话：13751002110'
        },
        // {
        //   id: 4, //用来代表每一个对象
        //   title: '广东昌恩电子科技', //标题
        //   title2: '广东昌恩电子科技有限公司',
        //   address: '地址：梅县畲江镇广州（梅州）产业转移工业园内',
        //   phone1: '电话：0753-2210988'
        // },
        // {
        //   id: 5, //用来代表每一个对象
        //   title: '广州昌恩智能科技', //标题
        //   title2: '广州昌恩智能科技有限公司',
        //   address:
        //     '地址： 广州市白云区广州民营科技园科泰二路13-19号高新区产业园',
        //   phone1: '电话：13922379181'
        // },
        {
          id: 6, //用来代表每一个对象
          title: '成都分公司', //标题
          title2: '深圳昌恩智能股份有限公司成都分公司',
          address: '地址：成都市青羊区正府街172号证大正府3201',
          phone1: '电话：028-66516388'
        },
        {
          id: 7, //用来代表每一个对象
          title: '东莞分公司', //标题
          title2: '深圳昌恩智能股份有限公司东莞分公司',
          address: '地址：广东省东莞市万江街道金鳌路9号1039室',
          phone1: '电话：0769-22289371'
        },
        {
          id: 8, //用来代表每一个对象
          title: '深圳市立进供应链有限公司', //标题
          title2: '深圳市立进供应链有限公司',
          address: '地址：深圳市盐田区深盐路南保发大厦5楼',
          phone1: '电话：0755-83932176'
        }
        // {
        //   id: 8, //用来代表每一个对象
        //   title: '福建分公司', //标题
        //   title2: '深圳昌恩智能股份有限公司福建分公司',
        //   address:
        //     '地址：福建省福州市鼓楼区软件大道89号福州软件园F区2号楼13层02室',
        //   phone1: '电话：0591-83852953'
        // }
        // {
        //   id: 9, //用来代表每一个对象
        //   title: '河源分公司', //标题
        //   title2: '深圳昌恩智能股份有限公司河源分公司 ',
        //   address: '地址：河源市丝茅塘拆迁安置点第二区D2栋第十二卡三楼',
        //   phone1: '电话：13825205601'
        // }
      ]
    }
  },
  mounted () {
    this.setScrollCenter()
  },
  methods: {
    change (index) {
      // 用来实现切换功能
      // 实现选项卡 切换操作 - 本质就是操作类名
      // 通过currentIndex操作
      this.index = index
      this.currentIndex = index
    },
    // 设置滚动居中
    setScrollCenter () {
      let scrollContainer = document.querySelector('.scrollContainer')

      let scrollContainerW = scrollContainer.offsetWidth
      console.log('offsetWidth获取元素的像素宽度', scrollContainerW)

      let itemList = document.querySelectorAll('.item')

      for (let i = 0; i < itemList.length; i++) {
        itemList[i].onclick = function () {
          // 获取到当前点击元素的 offsetLeft  - 包裹盒子 offsetWidth 的一半 + 当前点击元素 offsetWidth 的一半
          let scrollLeftNum =
            itemList[i].offsetLeft -
            scrollContainerW / 2 +
            itemList[i].offsetWidth / 2
          console.log(scrollLeftNum, '距离')
          scrollContainer.scrollLeft = scrollLeftNum
        }
      }
    }
  }
}
</script>

<style scoped>
.bk {
  position: relative;
  width: 100vw;
  height: 87.3333vw;
  background-image: url(../assets/img/联系我们_banner_mob.png);
  background-size: 100% 100%;
}
.bk div {
  position: absolute;
  top: 38.9333vw;
  left: 34.2667vw;
  font-family: AlibabaPuHuiTiB;
  color: #ffffff;
  line-height: 8.6667vw;
  letter-spacing: 1.6vw;
  font-size: 6.4vw;
}
ul {
  /* width: 100vw; */
  /* width: 600px; */
  /* height: 10.6667vw; */
  /* overflow-x: scroll;
  overflow-y: hidden; */
  display: flex;
  margin: 20px;
  scroll-behavior: smooth;
  overflow: auto;
}
ul li {
  position: relative;
  /* width: 25vw; */
  /* height: 10.6667vw; */
  /* line-height: 10.6667vw; */
  font-family: PingFangSC-Regular, PingFang SC;
  font-size: 3.2vw;
  font-weight: 400;
  text-align: center;
  margin: 0 10px;
  padding: 10px 0;
}
ul li p {
  white-space: nowrap;
  font-family: PingFangSC-Medium, PingFang SC, Microsoft YaHei;
  color: #1d1d1d;
  font-size: 3.2vw;
  font-weight: 500;
}
ul .header-title {
  font-weight: 600;
}
/* ul .active i {
  text-align: center;
  position: absolute;
  left: 6.1333vw;
  bottom: 0.2667vw;
  width: 12.8vw;
  height: 0.4vw;
  background-color: #140047;
  border-radius: 0.2667vw;
} */
ul .active {
  color: #140047;
  font-weight: 600;
  border-bottom: 2px solid #140047;
}
.information {
  /* padding-bottom: 24.6667vw; */
  padding-bottom: 14vw;
}
.information .all {
  width: 80%;
  min-height: 100vw;
  margin: 0 auto;
}
.information .all .name {
  margin-top: 8vw;
  margin-bottom: 4.4vw;
  /* width: 17.0667vw; */
  height: 6vw;
  line-height: 6vw;
  font-size: 4.2667vw;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #01021b;
}
.information .all .title {
  padding: 8vw 0;
}
.information .all p {
  line-height: 6.4vw;
  font-size: 3.2vw;
  color: #01021b;
  letter-spacing: 0.1333vw;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
}
.bom {
  width: 100%;
  height: 10.6667vw;
  line-height: 10.6667vw;
  background: #030e2c;
  color: #ffffff;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  margin-top: 5.3333vw;
  position: fixed;
  bottom: 0;
}
.bom span {
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  display: block;
  text-align: center;
  width: 100%;
  height: 10.6667vw;
  line-height: 10.6667vw;
  font-size: 3.2vw;
  opacity: 0.5;
  /* transform: scale(0.5); 
    transform-origin: 0 0; */
}
</style>



// WEBPACK FOOTER //
// src/components/call.vue